import React from 'react';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Flex } from 'antd';

import { useTheme } from '../../../../../hooks/useTheme';
import { usePromocodeControls } from '../hooks/usePromocodeControls';
import { PromocodeDTO } from '../service/promocodes.interface';
import { ConfirmationDialog } from '../../../../../shared/ui/ConfirmationDialog';
import { clearSelection } from '../../../../common/store/selectionSlice';
import { useAppDispatch } from '../../../../../store';

export const TableActions = ({ record }: { record: PromocodeDTO }) => {
    const { colorIcon } = useTheme();
    const { editPromocodes, deletePromocodes } = usePromocodeControls();

    const dispatch = useAppDispatch();

    const styles = {
        fontSize: '24px',
        color: colorIcon,
        cursor: 'pointer',
    };

    return (
        <Flex gap={16}>
            <EditOutlined
                onClick={() => editPromocodes(record)}
                style={styles}
            />

            <ConfirmationDialog
                activator={<DeleteOutlined style={styles} />}
                onConfirm={() => {
                    deletePromocodes([record]);
                    dispatch(clearSelection());
                }}
                title='Удалить'
                description={`Вы уверены что хотите удалить этот промокод?`}
                withCheckbox
            />
        </Flex>
    );
};
